import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export interface LoginRequest {
  email: string;
  password: string;
}

export const login = async (data: LoginRequest): Promise<any> => {
  const baseUrl = getApiBaseUrl();
  const endpoint = `${baseUrl}Login`;

  try {
    const response = await axios.post(endpoint, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Error desconocido" };
  }
};
